import { Controller } from 'stimulus';

class ToggleController extends Controller {
  static targets = ['panel'];

  toggle(e) {
    if (e?.currentTarget?.dataset.toggleTarget) {
      this._toggleTarget(e.currentTarget.dataset.toggleTarget);
    } else {
      this.panelTargets.forEach((el) => {
        this._handleToggle(el);
      });
    }
  }

  /**
   * Listener to handle select field event.
   * Will run the toggle method when any options defined
   * within the data-toggle-values attribute is selected
   * and the target element is already hidden.
   *
   * @param {Event} e change event
   * @return {void}
   */
  toggleVisibilityWhenSelected(e) {
    const selectedValue = e.target.selectedOptions[0].value;
    const toggleValues = e.target.dataset.toggleValues?.split(' ');
    const elementIsHidden =
      this.panelTarget.classList.contains('u-displayNone');

    if (toggleValues.includes(selectedValue) && elementIsHidden) {
      this.toggle(e);
    } else if (!elementIsHidden) {
      this.toggle(e);
    }
  }

  /**
   * Listener to handle keydown event.
   * Will run toggle method if esc key is pressed and
   * if target does not have 'u-displayNone' in class list.
   *
   * @param {Event} e keydown event
   * @return {void}
   */
  handleKeydown(e) {
    if (e.key === 'Escape') {
      if (!this.panelTarget.classList.contains('u-displayNone')) {
        this.toggle(e);
      }
    }
  }

  /**
   * Given an element, if a `data-toggle-class` attribute is provided,
   * toggle given class name. Else, toggle `u-displayNone`.
   *
   * @param {HTMLElement} elem element to toggle given class name
   * @returns {void}
   */
  _handleToggle(elem) {
    const toggleClass = elem.dataset.toggleClass
      ? elem.dataset.toggleClass
      : 'u-displayNone';
    elem.classList.toggle(toggleClass);
    // The toggleClass hides the element, so lack of its precence implies visible.
    this._fireToggleEvent(elem, !elem.classList.contains(toggleClass));
  }

  /**
   * Fires a custom JS event indicating the current toggle state of an element.
   *
   * @param {HTMLElement} elem The HTMLElement that was toggled.
   * @param {boolean} state The current state of the toggled element (on/off).
   * @returns {void}
   */
  _fireToggleEvent(elem, state) {
    if (!elem.dataset.toggleEvent) {
      return;
    }

    window.dispatchEvent(
      new CustomEvent(`pp:toggle:${elem.dataset.toggleEvent}`, {
        detail: {
          state,
        },
      })
    );
  }

  _toggleTarget(names) {
    names.split(' ').forEach((name) => {
      const targets = document.querySelectorAll(
        `[data-toggle-name~="${name}"]`
      );

      targets.forEach((el) => {
        this._handleToggle(el);
      });
    });
  }
}

export default ToggleController;
